import { useMemo } from 'react';
import { useItemsStore, useSearchStore } from '../store';
import { Category, Product } from '../interfaces/domain/menu';

export const useMenuPlates = () => {
  const menuDataCategories = useItemsStore(s => s.menuData?.categories);
  const query = useSearchStore(s => s.query);

  const hasFilter = query.trim().length > 0;

  const categoriesToDisplay = useMemo(() => {
    if (!menuDataCategories) return [];
    if (!hasFilter) return menuDataCategories;

    const lowerQuery = query.toLowerCase();

    const matchesProduct = (p: Product) =>
      p.title.toLowerCase().includes(lowerQuery) ||
      p.description?.toLowerCase().includes(lowerQuery) ||
      p.tags?.some(tag => tag.toLowerCase().includes(lowerQuery));

    return menuDataCategories
      .map((category: Category) => {
        const categoryMatches = category.name.toLowerCase().includes(lowerQuery);
        return {
          ...category,
          products: categoryMatches
            ? category.products || []
            : category.products?.filter(matchesProduct) || [],
        };
      })
      .filter((category) => category.products.length > 0);
  }, [query, menuDataCategories, hasFilter]);

  return {
    categoriesToDisplay,
    isEmpty: categoriesToDisplay.length === 0,
    hasFilter,
    query
  };
};